import { axiosBasic, axiosBearer } from "../config/axios-common";
import MedicalLink from "../models/MedicalLink";


const postInsertOrUpdateAcademic = async (data: any, professionalId: string) => {

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }
        const response = await axiosBasic.post(`/sam/v1/medicalLink/insertOrUpdate?professionalId=${encodeURIComponent(professionalId)}`, data, config);

        const responseData = await response.data;

        return responseData;

    } catch (e: any) {
        throw e;
    }
};

const CreateAndGetMedicalLinkFromTasy = async (requestId: string): Promise<MedicalLink[]> => {

    const response = await axiosBearer.post(`/sam/v1/medicalLink/CreateAndGetMedicalLinkFromTasy?requestId=${encodeURIComponent(requestId)}`, {}).then(response => {

        var result = new Array<MedicalLink>();

        if (response.data !== undefined && response.data.length > 0) {

            result = response.data.map((row: any) => {
                let item = MedicalLink.NewInstance();

                item.Id = row.id;
                item.OperationAreaId = row.operationAreaId;
                item.OperationAreaValue = row.operationAreaValue;
                item.NrRCE = row.nrRCE;
                item.TasyCode = row.tasyCode;
                item.RemoveTasy = row.removeTasy;

                return item;
            });
        }

        return result;
    })

    const responseData = await response;

    return responseData;

};



const exportedObject = {
    postInsertOrUpdateAcademic,
    CreateAndGetMedicalLinkFromTasy
};


export default exportedObject